import PageHero from "@/components/site/PageHero";
import ComplianceWall from "@/components/home/ComplianceWall";
import { useSEO } from "@/lib/seo";

const PARTNERS = [
  "CrowdStrike", "SentinelOne", "Palo Alto Networks", "Microsoft Sentinel",
  "Splunk", "Google Chronicle", "Wiz", "Prisma Cloud",
  "Okta", "CyberArk", "SailPoint", "Zscaler",
  "Netskope", "Cato Networks", "Claroty", "Nozomi Networks",
];

export default function Partners() {
  useSEO({
    title: "Partners & Certifications | RockLadder Technologies",
    description: "Technology partners and certification bodies we operate with — CrowdStrike, Sentinel, Wiz, CyberArk, Okta, Zscaler and more.",
    canonical: "https://rockladder.com/partners",
  });

  return (
    <>
      <PageHero
        eyebrow="PARTNERS & CERTIFICATIONS"
        title="The ecosystem we operate in."
        subtitle="Deep tech partnerships with the vendors that matter — plus the certifications that back our operations."
        breadcrumb={[{ label: "Partners" }]}
      />
      <section className="relative py-16">
        <div className="mx-auto max-w-[1440px] px-6 lg:px-10">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
            {PARTNERS.map((p) => (
              <div
                key={p}
                data-testid={`partner-${p.replace(/\s+/g, "-").toLowerCase()}`}
                className="glass-panel rounded-xl px-4 py-8 text-center transition-[border-color,transform] hover:border-gold hover:-translate-y-0.5"
              >
                <div className="font-mono text-[10px] tracking-[0.28em] text-gold-body">
                  {p.toUpperCase()}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <ComplianceWall />
    </>
  );
}
